import { FedexController } from "@/app/core/base/controllers/FedexController";
import { DateTranslate } from "@/app/core/util/DateTranslater";
import { FieldTypeObj } from "@/app/core/util/helpers/FieldTypeHelper";
import OnDataChange from "@/app/core/util/helpers/HandleChange";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

export default function FedexPickupCard({ delivery, min, max, reload }) {
    const [data, setData] = useState({});
    const [response, setResponse] = useState({});
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        console.log(delivery);
        if (delivery && delivery.fedexPickupCreatedAt != null) {
            setOpen(true);
        } else {
            setOpen(false);
        }
    }, [delivery])

    async function checkAvailability() {
        console.log("Comecando")
        setLoading(true);
        const base = {
            "pickupAddress": {
                "streetLines": [
                    delivery.origin.street,
                ],
                //   "urbanizationCode": "string",
                "city": delivery.origin.city,
                "stateOrProvinceCode": delivery.origin.state,
                "postalCode": delivery.origin.zipCode,
                "countryCode": delivery.origin.country,
                "residential": false,
                //   "addressClassification": "string"
            },
            "dispatchDate": data.dispatchDate,
            "packageReadyTime": data.packageReadyTime,
            "customerCloseTime": data.customerCloseTime,
            "pickupType": "ON_CALL",
            "pickupRequestType": [
                "FUTURE_DAY"
            ],
            "shipmentAttributes": {
                // "serviceType": "string",
                "weight": {
                    "units": "KG",
                    "value": delivery.boxes[0].weight
                },
                "packagingType": "YOUR_PACKAGING",
                "dimensions": {
                    "length": delivery.boxes[0].width,
                    "width": delivery.boxes[0].depth,
                    "units": "CM",
                    "height": delivery.boxes[0].height
                }
            },
            // "numberOfBusinessDays": 0,
            // "packageDetails": [
            //   {
            //     "packageSpecialServices": {
            //       "specialServiceTypes": [
            //         "string"
            //       ]
            //     }
            //   }
            // ],
            // "associatedAccountNumber": "string",
            // "associatedAccountNumberType": "string",
            "carriers": [
                "FDXE"
            ],
            "countryRelationship": "INTERNATIONAL"
        }

        await FedexController.CheckAvailability(base, res => {
            console.log("Resultado", res);
            setResponse(res);

            if (res && res.output != undefined && res.output.options != null) {
                const basePickup = {
                    "deliveryId": delivery.id,
                    "deliveryInstructions": data.userMessage,
                    "readyDateTimestamp": `${data.dispatchDate}T${data.packageReadyTime}:00`,
                    "customerCloseTime": `${data.customerCloseTime}:00`,
                    "pickupDateType": "FUTURE_DAY",
                    "carrierCode": "FDXE",
                    "pickupType": "ON_CALL",
                    // "packageLocation": "string",
                    // "buildingPart": "string",
                    // "buildingPartDescription": "string",
                    // "earlyPickup": true,
                    // "suppliesRequested": "string",
                    // "geographicalPostalCode": "string",
                    // "remarks": "string",
                    // "commodityDescription": "string",
                    // "expressFreightDetail": {
                    //     "truckType": "string",
                    //     "service": "string",
                    //     "trailerLength": "string",
                    //     "bookingNumber": "string",
                    //     "dimensions": {
                    //         "length": 0,
                    //         "width": 0,
                    //         "height": 0,
                    //         "units": "string"
                    //     }
                    // },
                    "pickupNotificationDetail": {
                        "emailDetails": [
                            {
                                "address": delivery.origin.email,
                                "locale": "pt_BR"
                            }
                        ],
                        "format": "HTML",
                        // "userMessage": "string"
                    }
                };

                FedexController.PickupCreate(basePickup, result => {
                    console.log("Pickup completo", result);
                    toast.success("Entrega registrada");
                    reload()
                }, error => console.log("Erro", error))
            }
        }, error => console.log("Erro", error))
        setLoading(false);
    }

    function handleChange(evt, type) {
        setData(OnDataChange(data, evt, type));
    }

    function cancelCollect() {
        if (window.confirm(Translate(Message.Confirm))) {
            FedexController.CancelPickup({ deliveryId: delivery.id }, result => {
                toast.success("Cancelada com sucesso");
                setOpen(false)
                reload()
            })
        }
    }

    return (
        <div className="block block-rounded block-bordered border-2x border-info">
            <div className="block-header">
                <div className="block-title">{delivery && delivery.fedexPickupCreatedAt != null ? "Coleta agendada" : "Agendar coleta"}</div>
                <div className="block-tools">
                    <div class="custom-control custom-switch custom-control-success mb-1">
                        <input
                            type="checkbox"
                            name="example-sw-success2"
                            id="example-sw-custom-success2"
                            disabled={delivery.fedexPickupCreatedAt != null ? true : false}
                            className="custom-control-input"
                            onChange={evt => setOpen(evt.target.checked)} checked={open} />
                        <label className="custom-control-label" for="example-sw-custom-success2"></label>
                    </div>
                </div>
            </div>
            {open &&
                <div className="block-content">
                    {delivery && delivery.fedexPickupCreatedAt != null ?
                        <div>
                            <div className="row">
                                <div className="form-group col-md-3">
                                    <span>{Translate(Message.CollectionDate)}</span><br />
                                    {delivery && DateTranslate(delivery.fedexPickupReadyAt)}
                                </div>
                                <div className="form-group col-md-3">
                                    <span>Cód. de confirmação</span><br />
                                    {delivery && delivery.fedexPickupConfirmationCode}
                                </div>
                                <div className="form-group col-md-3">
                                    <span>Cód. de carregamento</span><br />
                                    {delivery && delivery.fedexPickupCarrierCode}
                                </div>
                                <div className="form-group col-md-3">
                                    <span>Local de Carregamento</span><br />
                                    {delivery && delivery.fedexPickupLocation}
                                </div>

                                <div className="col-md-12 text-center">
                                    <button className="btn btn-block btn-warning mb-4 mt-2" onClick={() => cancelCollect()}>Cancelar coleta agendada</button>
                                </div>
                            </div>
                        </div>
                        : ""}
                    {delivery && delivery.fedexPickupCreatedAt == null ?
                        <div>
                            <div className="row">
                                <div className="form-group col-md-3">
                                    <span>{Translate(Message.CollectionDate)}</span>
                                    <input type="date" className="form-control" name="dispatchDate" min={min} max={max} value={data && data.dispatchDate} onChange={evt => handleChange(evt, FieldTypeObj.Date)} />
                                </div>
                                <div className="form-group col-md-3">
                                    <span>{Translate(Message.CollectionInitialTime)}</span>
                                    <input type="time" className="form-control" name="packageReadyTime" value={data && data.packageReadyTime} onChange={evt => handleChange(evt)} />
                                </div>
                                <div className="form-group col-md-3">
                                    <span>{Translate(Message.CollectionFinalTime)}</span>
                                    <input type="time" className="form-control" name="customerCloseTime" value={data && data.customerCloseTime} onChange={evt => handleChange(evt)} />
                                </div>
                                <div className="col-md-3">
                                    <button className="btn btn-block btn-info mt-4" onClick={() => checkAvailability()}>Confirmar</button>
                                </div>
                                <div className="form-group col-md-9">
                                    <span>{Translate(Message.CollectionInstructions)}</span>
                                    <textarea className="form-control" name="userMessage" value={data && data.userMessage} onChange={evt => handleChange(evt)} />
                                </div>
                            </div>
                        </div>
                        : ""}
                    {loading === true ? (
                        <div className="block-content text-center">
                            <i className={"fa fa-circle-notch fa-spin text-info fa-2x"}></i>
                        </div>
                    ) : ""}
                    {response && response.output != undefined && response.output.options == null ?
                        <div className="text-center">
                            <i className="fa fa-exclamation-circle text-danger" /> Não há disponibilidade para esse agendamento
                        </div>
                        : ""}
                </div>
            }
        </div>
    )

}